import { EnergyMetric } from '../../model/energy-unit/energy-metric';
import { WeightMetric } from '../../model/prefixed-unit/weight.metric';

export const unitFactors = {
  [WeightMetric.Gram]: -6,
  [WeightMetric.KiloGram]: -3,
  [WeightMetric.Tonne]: 0,
  [WeightMetric.KiloTonne]: 3,
  [WeightMetric.MegaTonne]: 6,
  [WeightMetric.GigaTonne]: 9,
} as const;

export const energyUnitFactors = {
  [EnergyMetric.kWh]: 0,
  [EnergyMetric.MWh]: 3,
  [EnergyMetric.GWh]: 6,
  [EnergyMetric.TWh]: 9,
  [EnergyMetric.PWh]: 12,
  [EnergyMetric.MMBtu]: 0,
  [EnergyMetric.billionBtu]: 3,
  [EnergyMetric.trillionBtu]: 6,
  [EnergyMetric.quadrillionBtu]: 9,
  [EnergyMetric.quintillionBtu]: 12,
} as const;
